import React from 'react';
import { useDispatch } from 'react-redux';
import { externalLoginFinished } from '../../reducers/user';
import { StoreDispatch } from '../../store';
import * as styles from './styles.module.scss';

const ExternalLogin: React.FC = () => {
  const dispatch = useDispatch<StoreDispatch>();

  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <div className={styles.form}>
          <div className={styles.form_content}>
            <h2 className={styles.title_smaller}>
              Complete the login process in the browser window that just opened.
            </h2>
            <div className={styles.form_body}>
              <a
                onClick={() => {
                  dispatch(externalLoginFinished());
                }}
                className={styles.link}
                rel='noreferrer'
              >
                Go back to login.
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalLogin;
